import React, {Component} from 'react';
import {ButtonToolbar, Col, ProgressBar, Row} from "react-bootstrap";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import {TopAlertUwaga} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import DateAndTimeFormat from "../../../../../../utilities/DateAndTimeFormat";
import ReactTooltip from "react-tooltip";
import acc from "accounting";
import {Link} from "react-router-dom";
import LSService from "../../../../../../utilities/localStorageService/LSService";

var tinycolor = require("tinycolor2");


export default class KalendarzEventMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event: this.props.event
        };
    }

    componentDidMount() {
        console.log(this.props.event)
        this.setState({event: this.props.event})
    }

    componentWillReceiveProps(nextprops) {
        this.setState({event: nextprops.event})
    }

    renderStatusKursu() {
        if (this.state.event.zablokowane === 0) {
            return <span style={{color: 'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
        }
        else if (this.state.event.zablokowane === 1) {
            return <span style={{color: 'darkorange'}}><i className={'fa fa-times'}></i> zablokowany</span>
        }
        else if (this.state.event.zablokowane === 2) {
            return <span style={{color: 'firebrick'}}><i className={'fa fa-repeat'}></i> odwołany</span>
        }
    }

    renderKierowca(row) {

        if ((row.id_ki_oryg !== row.id_ki) && Boolean(row.id_ki_oryg)) {
            // gdy była zmiana kierowcy
            return (<span>
                <span data-tip='' data-for={'obsada_row' + row.id_ob} data-place="bottom" className='tooltip_here' style={{cursor: 'pointer'}}>
                    <span style={row.zablokowane === 2 ? {color: 'grey'} : {}}>
                        <a>
                            {row.imie_naz}
                        </a>
                    </span>
                    <span
                        style={{color: 'grey', fontSize: '14px', fontStyle: 'italic', marginLeft: '5px'}}>zamiana za: {row.imie_naz_kier_oryg}</span>
                </span>
                <ReactTooltip id={'obsada_row' + row.id_ob}>
                    <div>
                        <p><label>Obecny kierowca: </label>{row.imie_naz}</p>
                        <p><label>Oryginalny kierowca: </label>{row.imie_naz_kier_oryg}</p>
                        <p><label>Powód zamiany:</label> {Boolean(row.uwagi) ? row.powod_zam + ' ' + row.uwagi : row.powod_zam}</p>
                        <p><label>Typ płatności:</label> {(row.typ_plat == 'EXTRA') ? row.typ_plat + ' ' + acc.formatMoney(row.stawka) : row.typ_plat}
                        </p>
                    </div>
                </ReactTooltip>
            </span>)
        } else {
            // gdy kierowca nie był zmieniany

            return <span style={row.zablokowane === 2 ? {color: 'grey'} : {}}>{row.imie_naz}</span>
        }
    }

    renderEkipa(row) {
        if (Boolean(row.kolor) && row.kolor !== 'inherit') {

            let color = 'grey';

            if ((tinycolor(row.kolor)).isDark()) {
                color = '#ffffff'
            }
            if ((tinycolor(row.kolor)).isLight()) {
                color = '#000000'
            }

            return (
                <span>
                <span className={'label label-ebus-default'}
                      title={row.kolor}
                      style={(row.kolor.length > 1) ? {background: row.kolor, color: color} : {background: '#f5f5f5', color: '#333333'}}>
                    {row.kod_ek}
                    </span>
                </span>)
        } else {
            return (<span>{Boolean(row.kod_ek) ? row.kod_ek : '-'}</span>)
        }
    }

    onClickWyszukajBiletyNaKurs(obj) {
        let params = {
            idTr: obj.id_tr,
            godz: obj.godz_1p,
            data: obj.data
        }
        LSService.ustawWyszukiwanieBiletowZObsad(params);
    }

    renderMiejsca(row) {

        let wszystkie = 25
        if (row.il_miejsc_kurs > 0) {
            wszystkie = row.il_miejsc_kurs
        }

        let ile_odbic = 0;
        if(Boolean(row.ile_odb_mies_popr)){
            ile_odbic=row.ile_odb_mies_popr
        }

        // wartości procentowe
        let zarezerwowane = 0
        let sprzedane = 0
        let skasowane = 0
        let miesieczne = 0

        if (row.il_rez > 0) {
            zarezerwowane = (row.il_rez * 100) / wszystkie
        }
        if (row.il_sprz > 0) {
            sprzedane = (row.il_sprz * 100) / wszystkie
        }
        if (row.il_skas > 0) {
            skasowane = (row.il_skas * 100) / wszystkie
        }
        if(ile_odbic>0)
            miesieczne = (ile_odbic *100)/wszystkie

        return (
            <Link target={'_blank'} to={'/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe'}
                  title={'Kliknij aby wyszukać zakupione bilety i rezerwacje na ten kurs'} onClick={() => this.onClickWyszukajBiletyNaKurs(row)}>
                <div>
                    {
                        (wszystkie - row.il_rez - row.il_sprz - row.il_skas - ile_odbic < 0) ?
                            <ProgressBar style={{marginBottom: '2px'}}>
                                <ProgressBar bsStyle="danger"
                                             now={(Math.abs(wszystkie - row.il_rez - row.il_sprz - row.il_skas - ile_odbic) * (100 / wszystkie))} key={1}
                                             style={{background: 'firebrick'}}/>
                            </ProgressBar>
                            :
                            <ProgressBar style={{marginBottom: '2px'}}>
                                <ProgressBar bsStyle="primary"
                                             style={{background: this.props.kolorRezerwacja}}
                                             now={zarezerwowane} key={1}/>
                                <ProgressBar bsStyle="success"
                                             style={{background: this.props.kolorSprzedany}}
                                             now={sprzedane} key={2}/>
                                <ProgressBar bsStyle="warning"
                                             style={{background: this.props.kolorSkasowany}}
                                             now={skasowane} key={3}/>
                                <ProgressBar bsStyle="warning"
                                             style={{background: "#61135e"}}
                                             now={miesieczne} key={4}/>
                            </ProgressBar>
                    }
                    <div style={{fontSize: '16px'}}>
                        <span title={'Ilość miejsc zarezerowanych'} className={'text-primary'}
                              style={{fontWeight: 'bold', cursor: 'pointer', color: this.props.kolorRezerwacja}}>
                           Rezerwacje: {row.il_rez}
                        </span>,
                        <span title={'Ilość miejsc sprzedanych'} className={'text-success'}
                              style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: this.props.kolorSprzedany}}>
                           Sprzedane: {row.il_sprz}
                        </span>,
                        <span title={'Ilość skasowanych miejsc'}
                              style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: this.props.kolorSkasowany}}>
                           Skasowane: {row.il_skas}
                        </span>,
                        <span title={'Ilość odbić miesięcznych poprawnych / niepoprawnych'}
                              style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: "#61135e"}}>
                                Odbicia miesieczne: poprawne:{ile_odbic}{row.ile_odb_mies_niepopr?<span>/niepoprawne<span style={{color:'red'}}>{row.ile_odb_mies_niepopr}</span></span>:''}
                        </span>,
                        {
                            (wszystkie - row.il_rez - row.il_sprz - row.il_skas < 0) ?
                                <span title={'Ilość brakujących miejsc'}
                                      style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: 'firebrick'}}>
                           Brakujace: {(wszystkie - row.il_rez - row.il_sprz - row.il_skas)}
                        </span>
                                :
                                <span title={'Ilość wolnych miejsc'}
                                      style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: '#222'}}>
                           Wolne: {(row.il_miejsc_kurs > 0) ? wszystkie - row.il_rez - row.il_sprz - row.il_skas : '?'}
                        </span>
                        }

                        ,<span title={'Ilość wszystkich miejsc'} className={'text-primary'}
                               style={{fontWeight: 'bold', cursor: 'pointer', color: 'grey'}}>
                           Wszystkie: {wszystkie}
                        </span>
                    </div>
                    {
                        (row.il_miejsc_kurs > 0) ?
                            (wszystkie - row.il_rez - row.il_sprz - row.il_skas < 0) ?
                                <div style={{color: 'firebrick', textAlign: 'center', marginTop: '3px', fontSize: '12px'}}>
                                    <i className={'fa fa-exclamation-circle'}></i> Brak wolnych miejsc - należy utworzyć kurs bisowy
                                </div>
                                :
                                ''
                            :
                            ''
                    }
                </div>
            </Link>
        )

    }

    render() {

        return (
            <div className={'kalendarzEventMenu'}>
                <div style={{
                    position: 'absolute',
                    right: '15px',
                    marginRight: '15px',
                    marginTop: '15px'
                }}>
                    <TopButtonAction text={'Zamknij'} iconType={'fa fa-times'} btnColor={'default'}
                                     onClick={() => {
                                         this.props.handleZamknijMenu()
                                     }}/>
                </div>
                {
                    Boolean(this.state.event) ?
                        <div className={'thumbnail'} style={{padding: '15px'}}>
                            <h3>
                                Kurs nr <span className={'label label-ebus-primary'} style={(this.state.event.zablokowane == 2) ? {
                                fontSize: 'inherit',
                                background: 'grey'
                            } : {fontSize: 'inherit'}}>{this.state.event.id_ku}</span> {this.renderStatusKursu()}
                            </h3>
                            <Row>
                                <Col xs={3}>
                                    <h4 style={{margin: '15px 0'}}>
                                        <div style={{color: 'grey', fontSize: '14px', fontStyle: 'italic', marginBottom: '5px'}}>Informacje o kursie
                                        </div>
                                        <p>
                                            <i className={'fa fa-road'}></i> Trasa: {this.state.event.naz_tr}
                                        </p>
                                        <p>
                                            <i className={'fa fa-sign-in'}></i> Odjazd: {this.state.event.data}, {DateAndTimeFormat.formatHHMM(this.state.event.godz_1p)}
                                        </p>
                                        <p>
                                            <i className={'fa fa-sign-out'}></i> Przyjazd: {this.state.event.end.toJSON().substr(0, 10)}, {this.state.event.przyjazdO}
                                        </p>
                                        <p>
                                            <i className={'fa fa-clock-o'}></i> Czas trwania: {DateAndTimeFormat.formatHHMM(this.state.event.czas_tr)}
                                        </p>
                                    </h4>
                                </Col>
                                <Col xs={3}>
                                    <h4 style={{margin: '15px 0'}}>
                                        <div style={{color: 'grey', fontSize: '14px', fontStyle: 'italic', marginBottom: '5px'}}>Informacje o
                                            obsadzie
                                        </div>
                                        <p>
                                            <i className={'fa fa-group'}></i> Ekipa: {this.renderEkipa(this.state.event)}
                                        </p>
                                        <p>
                                            <i className={'fa fa-user'}></i> Kierowca: {this.renderKierowca(this.state.event)}
                                        </p>
                                        <p>
                                            <i className={'fa fa-bus'}></i> Pojazd: {this.state.event.naz_po}
                                        </p>
                                    </h4>
                                </Col>
                                <Col xs={6}>
                                    <h4 style={{margin: '15px 0'}}>
                                        <div style={{color: 'grey', fontSize: '14px', fontStyle: 'italic', marginBottom: '5px'}}>Informacje o
                                            sprzedaży
                                        </div>
                                        <div>
                                            {this.renderMiejsca(this.state.event)}
                                        </div>
                                    </h4>
                                </Col>
                            </Row>

                            <div>
                                <ButtonToolbar>
                                    <Link target={'_blank'} to={'/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe'}
                                          title={'Kliknij aby wyszukać zakupione bilety i rezerwacje na ten kurs'}
                                          onClick={() => this.onClickWyszukajBiletyNaKurs(this.state.event)}>
                                        <TopButtonAction iconType={'fa fa-ticket'} text={'Zobacz bilety na kurs'}/>
                                    </Link>
                                    <TopButtonAction iconType={'fa fa-map-marker'} text={'Zobacz lokalizację busu'} btnColor={'default'}/>
                                    <TopIf isTrue={this.state.event.zablokowane === 0 || this.state.event.zablokowane === 1}>
                                        <TopButtonAction iconType={'fa fa-user-plus'} text={'Duplikuj kurs'} btnColor={'success'}/>
                                        <TopButtonAction iconType={'fa fa-edit'} text={'Edytuj kierowcę i / lub pojazd'} btnColor={'info'}/>
                                    </TopIf>
                                    <TopIf isTrue={this.state.event.zablokowane === 0}>
                                        <TopButtonAction iconType={'fa fa-times'} text={'Zablokuj kurs'} btnColor={'default'}
                                                         className={'btn-status-niedostepny'}/>
                                    </TopIf>
                                    <TopIf isTrue={this.state.event.zablokowane === 1}>
                                        <TopButtonAction iconType={'fa fa-check'} text={'Odblokuj kurs'} btnColor={'default'}
                                                         className={'btn-status-dostepny'}/>
                                    </TopIf>

                                    <TopIf isTrue={this.state.event.zablokowane === 0 || this.state.event.zablokowane === 1}>
                                        <TopButtonAction iconType={'fa fa-repeat'} text={'Odwołaj kurs'} btnColor={'default'}
                                                         className={'btn-status-odwolany'}/>
                                    </TopIf>
                                </ButtonToolbar>
                            </div>
                        </div>
                        :
                        <TopAlertUwaga text={'Błąd podczas załadowania danych o kursie'}/>
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaKalendarz/components/KalendarzEventMenu.js